import { render, staticRenderFns } from "./antiDisease.vue?vue&type=template&id=313379f6&scoped=true"
import script from "./antiDisease.vue?vue&type=script&lang=js"
export * from "./antiDisease.vue?vue&type=script&lang=js"
import style0 from "./antiDisease.vue?vue&type=style&index=0&id=313379f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313379f6",
  null
  
)

export default component.exports